export const webSafeFonts = {
    cursive: `Bradley Hand, cursive`,
    'sans-serif': `Verdana, sans-serif`,
    serif: `Palatino, serif`,
    monospace: `Lucida, monospace`,
    fantasy: `luminari, papyrus, fantasy`
};

//# sourceMappingURL=constants.js.map